<template>

	<v-menu v-model="menu" location="bottom">

		<template v-slot:activator="{ props }">
			<ProfilePicRoundByUrl v-bind="props" :imageUrl="userStore.user.picture" class="pointer profile-pic__menu">
			</ProfilePicRoundByUrl>
		</template>



		<BasicTile :width="300" class="rounded-lg profile-menu-list-background">

			<v-list class="profile-dropdown-list">
				<v-list-item to="/profile"> My Profile</v-list-item>
				<v-list-item to="/myearning"> My Earnings</v-list-item>
				<v-list-item to="/status/in-progress"> My Offers</v-list-item>
				<v-list-item to="/reward/myRewardsList"> My Rewards</v-list-item>
				<v-list-item to="/myreferrals"> My Referrals</v-list-item>
				<v-list-item v-if="!isDesktopDevice" to="/faq">Support</v-list-item>
				<v-list-item to="/leaderboard">Leaderboard</v-list-item>
				<v-list-item v-if="showInstallOption" @click="installApp" class="d-flex flex-row align-center">
					<v-icon class="mr-2">mdi-download</v-icon>
					<span>Install App</span>
				</v-list-item>
				<v-list-item v-if="showInstallPrompt" @click="openDialog = true" class="d-flex flex-row align-center">
					<v-icon class="mr-2">mdi-download</v-icon>
					<span>Install App Prompt</span>
				</v-list-item>
			</v-list>


			<v-divider style="width: 90%" class="mx-auto"></v-divider>


			<v-list class="profile-dropdown-list">
				<v-list-item @click="logout" class="d-flex flex-row justify-center">
					<v-icon>
						<signout></signout>
					</v-icon>
					<span class="font-weight-medium">Logout</span>
				</v-list-item>
			</v-list>


		</BasicTile>
	</v-menu>

	<InstallPWADialogForApple 
		:device-info="deviceParams"
		:is-mac-safari="deviceParams?.os_name === 'Mac OS' && deviceParams?.browser_name === 'Safari'"
	/>

</template>



<script setup>

import { useRouter } from "vue-router";
import Signout from "@/icons/Signout.vue";
import { isDesktop } from "@/utils/utils.ts";
import { ref, onMounted, provide } from "vue";
import { useAuthStore } from "@/store/AuthStore";
import { useUserStore } from "@/store/UserStore";
import { useAppConfigStore } from "@/store/AppConfigStore";
import { useDeviceParams } from "@/composables/device.config";
import BasicTile from "@/components/Tiles/Basic-Tile.vue";
import InstallPWADialogForApple from "./InstallPWADialogForApple.vue";
import ProfilePicRoundByUrl from "../Profile/Profile-Pic-Round-By-URL.vue";

const menu = ref(false);
const router = useRouter();
const authStore = useAuthStore();
const userStore = useUserStore();
const appConfigStore = useAppConfigStore();
const isDesktopDevice = isDesktop();

const openDialog = ref(false);

provide("openDialog", openDialog);

const showInstallOption = ref(false);
const showInstallPrompt = ref(false);
const { deviceParams } = useDeviceParams();
let deferredPrompt = null; // Store the install prompt event

// Check if the app can be installed
onMounted(() => {
	// Show prompt for iOS/iPadOS (any browser) or Safari on macOS
	if (deviceParams.value?.os_name === 'iOS' || 
		deviceParams.value?.os_name === 'iPadOS' || 
		(deviceParams.value?.os_name === 'Mac OS' && deviceParams.value?.browser_name === 'Safari')) {
		showInstallPrompt.value = true;
		showInstallOption.value = false;
	} else {
		// For other browsers, use the standard install prompt
		window.addEventListener('beforeinstallprompt', (e) => {
			// Prevent Chrome 67 and earlier from automatically showing the prompt
			e.preventDefault();
			// Stash the event so it can be triggered later
			deferredPrompt = e;
			showInstallOption.value = true;
		});

		window.addEventListener('appinstalled', () => {
			// App is installed, hide the install option
			showInstallOption.value = false;
			deferredPrompt = null;
			// Optional: Track successful installation
			console.log('PWA was installed');
		});
	}
});

const installApp = async () => {
	if (!deferredPrompt) {
		console.log('Installation prompt not available');
		return;
	}

	// Show the install prompt
	deferredPrompt.prompt();

	// Wait for the user to respond to the prompt
	const { outcome } = await deferredPrompt.userChoice;
	console.log(`User response to the install prompt: ${outcome}`);

	// Clear the deferredPrompt for the next time
	deferredPrompt = null;
};

const logout = async () => {
	try {
		// First, clear application state and tokens
		await authStore.logout();
		
		// Then reset other stores
		appConfigStore.resetRelatedStores();
		userStore.clearStoreData();
		
		// Use location.href for a clean redirect to home
		window.location.href = "/";
	} catch (error) {
		console.error('Error during logout:', error);
		// Force a reload to home page if there's an error
		window.location.href = "/";
	}
}

</script>



<style lang="scss">
.profile-dropdown-list {
	background-color: transparent !important;
}

.profile-menu-list-background {
	background: vars.get-map-value(vars.$backgrounds, tile, secondary);
}
</style>
